import React from 'react';
import { Shield, Users, Zap } from 'lucide-react';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center w-full bg-gray-900 dark:bg-black">
        
        <div className="relative z-10 px-6 lg:px-8 py-20 text-center text-white w-full max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            About <span className="text-orange-400">Rust-Squad.com</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            15+ years of expertise in professional rust prevention and equipment protection
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 px-6 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img
                src="/images/rusty train.png"
                alt="Industrial rust protection work"
                className="rounded-lg shadow-lg w-full"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
                Our Mission
              </h2>
              <p className="text-lg mb-6 text-gray-600 dark:text-gray-300">
                We specialize in comprehensive rust prevention, removal, and long-term surface protection. Our certified technicians use industry-leading techniques and premium coating systems to extend the life of your equipment and reduce maintenance costs.
              </p>
              <p className="text-lg mb-6 text-gray-600 dark:text-gray-300">
                From mobile rust removal services to scheduled preventative maintenance plans, we provide complete corrosion protection solutions for automotive, marine, and industrial applications.
              </p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-lg">
              <Shield className="h-12 w-12 text-orange-600 dark:text-orange-400 mx-auto mb-4" />
              <div className="text-3xl font-bold text-orange-600 dark:text-orange-400 mb-2">15+</div>
              <div className="text-gray-600 dark:text-gray-300">Years Experience</div>
            </div>
            <div className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-lg">
              <Users className="h-12 w-12 text-orange-600 dark:text-orange-400 mx-auto mb-4" />
              <div className="text-3xl font-bold text-orange-600 dark:text-orange-400 mb-2">5000+</div>
              <div className="text-gray-600 dark:text-gray-300">Assets Protected</div>
            </div>
            <div className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-lg">
              <Zap className="h-12 w-12 text-orange-600 dark:text-orange-400 mx-auto mb-4" />
              <div className="text-3xl font-bold text-orange-600 dark:text-orange-400 mb-2">24/7</div>
              <div className="text-gray-600 dark:text-gray-300">Emergency Response</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
